/*
 * Copyright (c) 2020.  Rikesh Lal Shrestha
 * All Rights Reserved
 */

export const ROLES_UPSERT_REQUEST = 'ROLES_UPSERT_REQUEST';
export const ROLES_UPSERT_REQUEST_SUCCESS = 'ROLES_UPSERT_REQUEST_SUCCESS';
export const ROLES_UPSERT_REQUEST_FAILURE = 'ROLES_UPSERT_REQUEST_FAILURE';

export const ROLES_FETCH_REQUEST = 'ROLES_FETCH_REQUEST';
export const ROLES_FETCH_REQUEST_SUCCESS = 'ROLES_FETCH_REQUEST_SUCCESS';
export const ROLES_FETCH_REQUEST_FAILURE = 'ROLES_FETCH_REQUEST_FAILURE';

export const ROLES_CLEAN_REQUEST = 'ROLES_CLEAN_REQUEST';
